import type { FileFilters } from '../../../../../types/file.types';

interface FilterGroupConfig {
  title: string;
  options: Array<{
    id: FileFilters;
    label: string;
  }>;
}

export const FILTER_GROUPS: FilterGroupConfig[] = [
  {
    title: 'Risque',
    options: [
      { id: 'isLowRisk', label: 'Faible' },
      { id: 'isMediumRisk', label: 'Moyen' },
      { id: 'isHighRisk', label: 'Élevé' },
    ],
  },
  // {
  //   title: 'Type de document',
  //   options: [
  //     { id: 'isImage', label: 'Image' },
  //     { id: 'isPdf', label: 'PDF' },
  //   ],
  // },
  {
    title: 'Statut',
    options: [
      { id: 'isFavorite', label: 'Fichiers favoris' },
      { id: 'isUnread', label: 'Fichiers non lus' },
      { id: 'isArchived', label: 'Fichiers archivés' },
    ],
  },
];

export const STANDALONE_FILTERS: Array<{
  id: FileFilters;
  label: string;
}> = [
  // { id: 'isFavorite', label: 'Fichiers favoris' },
  // { id: 'isUnread', label: 'Fichiers non lus' },
  // { id: 'isArchived', label: 'Fichiers archivés' },
];
